<template>
  <b-container class="pt-5">
    <div :content="content" ref="myQuillEditor" v-quill:myQuillEditor="editorOptions"></div>
    <div class="controls">
      <router-link :to="{path: '/'+path}">
        <b-button variant="danger" class="custom-btn mr-3">Go Back</b-button>
      </router-link>
      <b-button variant="primary" class="custom-btn" @click="saveContent()">Save</b-button>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios';
import { Quill } from 'vue-quill-editor';
import { quillEditor } from 'vue-quill-editor/dist/ssr';
import ImageResize from 'quill-image-resize-module';
import { ImageUpload } from 'quill-image-upload';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageUpload', ImageUpload);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: 'EditArticle',
  directives: {
    quill: quillEditor
  },
  data() {
    return {
      article: '',
      content: '<h2>I am Example</h2>',
      path: '',
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video']
          ],
          imageDropAndPaste: {
            handler: (imageDataUrl) => {
              let that = this;
              function dataURItoBlob(dataURI) {
                // convert base64/URLEncoded data component to raw binary data held in a string
                let byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0)
                  byteString = atob(dataURI.split(',')[1]);
                else byteString = unescape(dataURI.split(',')[1]);

                // separate out the mime component
                let mimeString = dataURI
                  .split(',')[0]
                  .split(':')[1]
                  .split(';')[0];

                // write the bytes of the string to a typed array
                let ia = new Uint8Array(byteString.length);
                for (let i = 0; i < byteString.length; i++) {
                  ia[i] = byteString.charCodeAt(i);
                }

                return new Blob([ia], { type: mimeString });
              }
              let blob = dataURItoBlob(imageDataUrl);
              let bodyFormData = new FormData();
              bodyFormData.set('folder_paths', 'NUIWIKI');
              bodyFormData.append('image', blob);
              axios({
                method: 'post',
                url: process.env.VUE_APP_BASE_URL + '/' + 'upload',
                data: bodyFormData,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
              })
                .then(function(response) {
                  var index =
                    (that.myQuillEditor.getSelection() || {}).index ||
                    that.myQuillEditor.getLength();
                  if (index)
                    that.myQuillEditor.insertEmbed(
                      index,
                      'image',
                      response.data.url,
                      'user'
                    );
                })
                .catch(function() {
                  //handle error
                });
            }
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageUpload: {
            url: process.env.VUE_APP_BASE_URL + '/' + 'upload', // server url. If the url is empty then the base64 returns
            method: 'POST',
            name: 'image',
            withCredentials: false,
            customUploader: (file, next) => {
              let bodyFormData = new FormData();
              bodyFormData.set('folder_paths', 'NUIWIKI');
              bodyFormData.append('image', file);
              axios({
                method: 'post',
                url: process.env.VUE_APP_BASE_URL + '/' + 'upload',
                data: bodyFormData,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
              })
                .then(function(response) {
                  response;
                  next(response.data.url);
                })
                .catch(function(response) {
                  response;
                });
            }, // add custom uploader
            callbackOK: (serverResponse, next) => {
              next(serverResponse);
            },
            callbackKO: () => {},

            checkBeforeSend: (file, next) => {
              next(file); // go back to component and send to the server
            }
          },
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/' +
          to.params.productId +
          '/' +
          to.params.appId +
          '/' +
          to.params.sectionId +
          '/' +
          to.params.articleId
      )
      .then(response => {
        let path =
          to.params.productId +
          '/' +
          to.params.appId +
          '/' +
          to.params.sectionId +
          '/' +
          to.params.articleId;
        next(vm => {
          vm.setData(response, path);
        });
      });
  },
  methods: {
    setData(article, path) {
      this.path = path;
      this.content = article.data.content;
    },
    imageHandler(dataUrl, type, imageData) {
      imageData.minify(miniImageData => {
        const blob = miniImageData.toBlob();
        const file = miniImageData.toFile('image.png');
        this.image = { type, dataUrl, blob, file };
        this.blobUrl = URL.createObjectURL(blob);
      });
    },
    saveContent() {
      axios
        .put(
          process.env.VUE_APP_BASE_URL +
            '/' +
            this.$route.params.productId +
            '/' +
            this.$route.params.appId +
            '/' +
            this.$route.params.sectionId +
            '/' +
            this.$route.params.articleId,
          { content: this.myQuillEditor.root.innerHTML }
        )
        .then(response => {
          response;
        });
    }
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },

  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ql-container {
  height: 600px;
}
#editor {
  height: 375px;
}
.custom-btn {
  width: 120px;
  margin-left: auto;
}
.controls {
  width: 100%;
  text-align: right;
  padding-top: 20px;
}
</style>
